import { Typography } from '@mui/material';
import React from 'react'
import { Heading_Text_Color } from '../../constant/constant';
import { decrypt } from '../../components/cryptoUtil';

function DefaultDashboard() {
    const userfullname = (JSON.parse(decrypt(localStorage.getItem('tokenData'))).userfullname);
    
  return (
    <Typography  variant='h5' gutterBottom style={{ color: Heading_Text_Color, textAlign: 'center' }}>
          Welcome   <strong>{userfullname}</strong> 👑
    </Typography>
  );
}

export default DefaultDashboard